import React, { useState } from "react";
import { FormType } from "../types/Types";

interface IFormData {
  formData: FormType;
  setFormData: React.Dispatch<React.SetStateAction<FormType>>;
}

const FormContext = React.createContext<IFormData>({
  formData: {},
  setFormData: formData => formData
});

export const FormDataProvider: React.FC = ({ children }) => {
  const [formData, setFormData] = useState({});

  return (
    <FormContext.Provider
      value={{
        formData,
        setFormData
      }}>
      {children}
    </FormContext.Provider>
  );
};

export default FormContext;
